import type { ResErr } from '@/types/common/api'

// responseType: 'blob' 요청은 에러 본문도 Blob 으로 와서 그대로 구조분해하면 서버 code·message 가 사라진다.
export const readErrorBody = async (body: unknown): Promise<Partial<ResErr>> => {
  if (!(body instanceof Blob)) return (body ?? {}) as Partial<ResErr>
  if (!body.type.includes('json')) return {}
  try {
    const parsed: unknown = JSON.parse(await body.text())
    return parsed !== null && typeof parsed === 'object' ? (parsed as Partial<ResErr>) : {}
  } catch {
    return {}
  }
}
